import React, {useCallback} from 'react';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCFileInput from '../../../components/Simple/SMCFileInput';
import EmptyRow from '../../../components/Simple/EmptyRow';
import RowLayout from '../../../components/Layouts/RowLayout';

function ImportDomainSMPStepOne({
    onCancel,
    onNext,
    pageParams
}) {
    const { t } = useTranslation();

    const {
        fileToImport, setFileToImport,
    } = pageParams;

    const handleNext = useCallback(() => {
        if (!fileToImport) {
            alert(t('SMC_SYSOPS_IMPWIZ_NO_INPUT'));
        } else {
            if (window.confirm("Are you sure you want to override exiting data?")) {
                onNext();
            }
        }
    }, [fileToImport, onNext, t]);

    return (
        <>
        <SMCModalBody>
            <SMCLabel bold fontSize="16px">{t('SMC_SYSOPS_IMPWIZ_TEXT')}</SMCLabel>
            <RowLayout spacing="4px">
                <SMCLabel>
                    {t('SMC_SYSOPS_IMPWIZ_FILE')}
                </SMCLabel>
                <EmptyRow />
                <SMCFileInput
                    accept=".xml"  
                    onChange={fileList => {
                        if (fileList && fileList.length) {
                            setFileToImport(fileList[0]);
                        } else {
                            setFileToImport(undefined);
                        }
                    }}
                />
            </RowLayout>
            <SMCLabel tooltip={t('SMC_SYSOPS_IMPWIZ_RETAIN_CERTS_TOOLTIP')} bold>
                The import will replace existing data and retain existing certificate
            </SMCLabel>
            <SMCLabel bold>Note: Gateway needs to be reconnect to SMP after import</SMCLabel>
        </SMCModalBody>
        <SMCModalButtonContainer>
            <SMCButton onClick={handleNext}>
                {t('SMC_GEN_WIZNEXT')}
                <FontAwesomeIcon style={{ marginTop: '3px', marginLeft: '5px' }} color="grey" icon="arrow-circle-right" />
            </SMCButton>
            <SMCButton onClick={onCancel}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                {t('SMC_GEN_CANCEL')}
            </SMCButton>
        </SMCModalButtonContainer>
        </>
    )
}

export default ImportDomainSMPStepOne;